// extracted by mini-css-extract-plugin
export default {"screen":"Audio_screen__6Pkul","logo":"Audio_logo__KLzYL","body":"Audio_body__9yuP4","headerBox":"Audio_headerBox__j0xqW"};